import Style from './panelStyles.module.scss';
import { useNode } from '@craftjs/core';
import { FormDropdownInputProps } from '../../types/DropdownInput';
import { useScopedTranslation } from 'src/application/localisation/useScopedTranslation';
import { PanelContainer } from './uiKit/panelContainer/panelContainer';
import { ControlsGroup } from './uiKit/controlsGroup/controlsGroup';
import { SettingsInput } from './uiKit/input/settingsInput';
import { AppCheckboxInput } from 'uikit/inputs';

export const DropdownPanel = () => {
  const { t } = useScopedTranslation('GeneralFormBuilder.Panels.DropDownField');
  const {
    actions: { setProp },
    props,
  } = useNode((node) => ({
    props: node.data.props as FormDropdownInputProps,
  }));

  return (
    <PanelContainer header={t('Header')} panelName={'General'}>
      <ControlsGroup
        header={t('Placeholder')}
        collapsible={true}
        contentClassName={Style.flexContainer}
        expanded={!!props.placeholder}
        onOpen={() => {
          setProp((prop: FormDropdownInputProps) => {
            prop.placeholder = t('Placeholder');
          }, 500);
        }}
        onClose={() => {
          setProp((prop: FormDropdownInputProps) => {
            prop.placeholder = undefined;
          }, 500);
        }}
      >
        <SettingsInput
          placeholder={t('PlaceholderPlaceholder')}
          value={props.placeholder}
          onChange={(e) =>
            setProp((p: FormDropdownInputProps) => {
              p.placeholder = e.target.value || undefined;
            }, 500)
          }
        />
      </ControlsGroup>

      <ControlsGroup contentClassName={Style.flexContainer}>
        <AppCheckboxInput
          label={t('Suggestion')}
          checked={props.suggestion}
          onChange={(e) =>
            setProp((p: FormDropdownInputProps) => {
              p.suggestion = e.target.checked || undefined;
            }, 500)
          }
        />
      </ControlsGroup>
    </PanelContainer>
  );
};
